<p-tabView>
    <!-- <p-tabPanel header="Purchase Order">
        Purchase Order Content
    </p-tabPanel> -->
    <p-tabPanel header="Vendors">
        <p-accordion>
            <p-accordionTab header="Vendor Type">
                <p-table #db [value]="vendorTypes" [scrollable]="true" scrollHeight="180px" [reorderableColumns]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="max-width:3rem"></th>
                            <th class="p-col-10" pReorderableColumn>Name</th>
                            <th class="p-col-2" pReorderableColumn>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr [pReorderableRow]="index" style="cursor: move;">
                            <td style="max-width:3rem">
                                <span class="pi pi-bars" pReorderableRowHandle></span>
                            </td>
                            <td class="p-col-10" pReorderableRowHandle>{{data?.name}}</td>
                            <td class="p-col-2 action" pReorderableRowHandle>
                                <span class="btnBars p-mr-0" *ngIf="data?.organizationId!=0 && data?.createdSource!='system'" (click)="openPurchaseFieldVendorPopup(data,
                                    fieldDataConstants.Purchase_Field_Name)" pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i>
                                </span>
                                <!-- showEditProductData(data, fieldDataConstants.brandFieldName) -->
                                <span class="btnBars p-mr-0" *ngIf="data?.organizationId!=0 && data?.createdSource!='system'" (click)="delete(data,fieldDataConstants.Purchase_Field_Name, index)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab header="Account Category">
                <p-table #db [value]="businessTypes" [scrollable]="true" scrollHeight="180px" [reorderableColumns]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="max-width:3rem"></th>
                            <th class="p-col-10" pReorderableColumn>Name</th>
                            <th class="p-col-2" pReorderableColumn>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr [pReorderableRow]="index" style="cursor: move;">
                            <td style="max-width:3rem">
                                <span class="pi pi-bars" pReorderableRowHandle></span>
                            </td>
                            <td class="p-col-10" pReorderableRowHandle>{{data?.name}}</td>
                            <td class="p-col-2 action" pReorderableRowHandle>
                                <span class="btnBars p-mr-0" *ngIf="data?.organizationId!=0" (click)="openPurchaseFieldVendorPopup(data, fieldDataConstants.Purchase_Business_Field_Name)" pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i>
                                </span>
                                <span class="btnBars p-mr-0" *ngIf="data?.organizationId!=0" (click)="delete(data,fieldDataConstants.Purchase_Business_Field_Name, index)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab header="Number of Employees">
                <p-table [value]="employeesCounts" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="max-width:3rem"></th>
                            <th class="p-col-10">Name</th>
                            <th class="p-col-2">Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr>
                            <td style="max-width:3rem" class="action">
                                <span class="pi pi-bars"></span>
                            </td>
                            <td class="p-col-10">{{data.name}}</td>
                            <td class="p-col-2 action">
                                <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="openPurchaseFieldVendorPopup(data, fieldDataConstants.Purchase_Number_Of_Employee_Field_Name)" pTooltip="Edit" tooltipPosition="top">
                                    <i class="pi pi-pencil"></i></span>
                                <!-- showEditAccountData(data, fieldDataConstants.Purchase_Number_Of_Employee_Field_Name) -->
                                <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="delete(data,fieldDataConstants.Purchase_Number_Of_Employee_Field_Name, index)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                                <!-- delEmployeesNo(data) -->
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab header="Estimated Annual Revenue">
                <p-table [value]="revenue" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="max-width:3rem"></th>
                            <th class="p-col-10">Name</th>
                            <th class="p-col-2">Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr>
                            <td style="max-width:3rem" class="action">
                                <span class="pi pi-bars"></span>
                            </td>
                            <td class="p-col-10">{{data.name}}</td>
                            <td class="p-col-2 action">
                                <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="openPurchaseFieldVendorPopup(data, fieldDataConstants.Purchase_Estimated_Revenue_Field_Name)" pTooltip="Edit" tooltipPosition="top"><i class="pi
                                pi-pencil"></i></span>
                                <!-- (click)="showEditAccountData(data, accountDataTypes[5])" -->
                                <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="delete(data,fieldDataConstants.Purchase_Estimated_Revenue_Field_Name, index)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                                <!-- delRevenue(data) -->
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab header="Industry">
                <p-table [value]="industries" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="max-width:3rem"></th>
                            <th class="p-col-10">Name</th>
                            <th class="p-col-2">Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr>
                            <td style="max-width:3rem" class="action">
                                <span class="pi pi-bars"></span>
                            </td>
                            <td class="p-col-10">{{data.name}}</td>
                            <td class="p-col-2 action">
                                <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="openPurchaseFieldVendorPopup(data, fieldDataConstants.Purchase_Industry_Field_Name)" pTooltip="Edit" tooltipPosition="top">
                                    <!-- (click)="showEditAccountData(data, accountDataTypes[7])" -->
                                    <i class="pi pi-pencil"></i>
                                </span>
                                <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="delete(data,fieldDataConstants.Purchase_Industry_Field_Name, index)" pTooltip="Delete" tooltipPosition="top">
                                    <!-- (click)="delIndustry(data)" -->
                                    <i class="pi pi-trash"></i>
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab header="Ownership Type">
                <p-table [value]="ownerships" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="max-width:3rem"></th>
                            <th class="p-col-10">Name</th>
                            <th class="p-col-2">Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr>
                            <td style="max-width:3rem" class="action">
                                <span class="pi pi-bars"></span>
                            </td>
                            <td class="p-col-10">{{data.name}}</td>
                            <td class="p-col-2 action">
                                <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="openPurchaseFieldVendorPopup(data, fieldDataConstants.Purchase_Ownership_Type_Field_Name)" pTooltip="Edit" tooltipPosition="top">
                            <i class="pi pi-pencil"></i>
                        <!-- (click)="showEditAccountData(data, accountDataTypes[6])" -->
                        </span>
                                <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="delete(data,fieldDataConstants.Purchase_Ownership_Type_Field_Name, index)" pTooltip="Delete" tooltipPosition="top">
                          <i class="pi pi-trash"></i>
                           <!-- (click)="delOwnership(data)" -->
                        </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
        </p-accordion>
    </p-tabPanel>
    <!-- <p-tabPanel header="Vendor returns">
        Vendor returns Content
    </p-tabPanel>
    <p-tabPanel header="Bills">
        Bills Content
    </p-tabPanel> -->
</p-tabView>


<p-dialog header="{{addEditPurchaseFieldHeader}}" [modal]="true" [(visible)]="showPurchaseFieldVendorForm" [style]="{width: '50vw'}" [baseZIndex]="10000" (onHide)="purchaseAddEditFieldForm.reset();invalidData=false">
    <form [formGroup]="purchaseAddEditFieldForm">
        <div class="p-grid">
            <div class="p-col-12" *ngIf="addEditPurchaseFieldHeader == fieldDataConstants.Purchase_Field_Add_Title">
                <label for="type">Fields Type <span style="color: red;">*</span></label>
                <p-dropdown [options]="purchaseFieldDataTypes" formControlName="fieldType" optionLabel="name" placeholder="Select Field Type" appendTo="body"></p-dropdown>
            </div>
            <div class="p-col-12" *ngIf="addEditPurchaseFieldHeader == fieldDataConstants.Purchase_Field_Edit_Title">
                <h5 class="p-mb-0">Fields Name -- {{selectedAccountType}}</h5>
            </div>
            <div class="p-col-12">
                <label for="name">Name <span style="color: red;">*</span></label>
                <input type="text" pInputText formControlName="name">
                <small *ngIf="invalidData" class="p-invalid">
                    Name exists in the list already
                </small>
            </div>
            <div class="p-col-12">
                <label for="name">Description</label>
                <input type="text" formControlName="description" pInputText style="width: 100%;">
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <button pButton (click)="showPurchaseFieldVendorForm=false" label="Cancel" class="p-button-secondary"></button>
        <button pButton [disabled]="!purchaseAddEditFieldForm.valid" (click)="updatePurchaseFieldsData()" label="Save"></button>
    </ng-template>
</p-dialog>



<!-- <p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog> -->